module.exports = __webpack_public_path__ + "img/imagen_parrafo_dos1.9ca9a896.jpg";